// Premium smartphone mockup — 2025/2026 flagship style.
// `bare` = hide dynamic island (use for real screenshots that already include device status bar).
export default function PhoneMockup({ children, className = "", bare = false, ...rest }) {
    return (
        <div
            {...rest}
            className={`relative mx-auto ${className}`}
            style={{ aspectRatio: "9 / 19.5", width: "100%" }}
        >
            {/* Outer glow */}
            <div className="absolute -inset-6 rounded-[60px] bg-[radial-gradient(circle_at_50%_30%,rgba(0,240,255,0.18),transparent_65%)] blur-2xl pointer-events-none" />

            {/* Titanium frame */}
            <div
                className="absolute inset-0 rounded-[44px] p-[6px] shadow-[0_40px_80px_-30px_rgba(0,0,0,0.9),0_0_0_1px_rgba(255,255,255,0.04)]"
                style={{
                    background:
                        "linear-gradient(145deg,#3a3a42 0%,#1a1a1e 20%,#2c2c32 45%,#15151a 65%,#3a3a42 100%)",
                }}
            >
                {/* Inner bezel */}
                <div className="relative w-full h-full rounded-[38px] bg-black overflow-hidden">
                    {/* Screen */}
                    <div className="absolute inset-[3px] rounded-[35px] overflow-hidden bg-[#0b0b10]">
                        {children}
                        {/* Inner shadow */}
                        <div
                            className="absolute inset-0 pointer-events-none rounded-[35px]"
                            style={{ boxShadow: "inset 0 0 24px rgba(0,0,0,0.55)" }}
                        />
                        {/* Glare */}
                        <div className="absolute inset-0 pointer-events-none phone-glare rounded-[35px]" />
                    </div>

                    {/* Dynamic island (hidden for real screenshots) */}
                    {!bare && (
                        <div className="absolute top-[10px] left-1/2 -translate-x-1/2 w-[34%] h-[22px] bg-black rounded-full border border-black/80 flex items-center justify-end pr-2">
                            <div className="w-1.5 h-1.5 rounded-full bg-[#222] mr-1" />
                        </div>
                    )}
                </div>
            </div>

            {/* Side buttons */}
            <span className="absolute left-[-3px] top-[22%] w-[3px] h-[34px] rounded-l bg-[#25252a]" />
            <span className="absolute left-[-3px] top-[32%] w-[3px] h-[54px] rounded-l bg-[#25252a]" />
            <span className="absolute left-[-3px] top-[44%] w-[3px] h-[54px] rounded-l bg-[#25252a]" />
            <span className="absolute right-[-3px] top-[28%] w-[3px] h-[80px] rounded-r bg-[#25252a]" />
        </div>
    );
}
